import { ImgBackgroundWrapper } from 'components/Common/CommonWrappers';
import { BodyTextL, GRAY50 } from 'global-styles';
import Image from 'next/image';
import React from 'react';
import styled from 'styled-components';

const Av1MSU = () => {
  return (
    <Av1MSUContainer>
      <div className="img-wrapper">
        <ImgBackgroundWrapper isNormalUse>
          <Image
            src="/asset/product/pulsar/04-AV1/msu.png"
            layout="fill"
            alt="bluedot"
            className="banner-img"
            quality={70}
            sizes="(min-width: 906px) 90vw,
          (min-width: 600px) 85vw,
          (max-width: 599px) 75vw"
          />
        </ImgBackgroundWrapper>
      </div>

      <BodyTextL className="link-wrapper" as="div">
        <span>Link: </span>
        <BodyTextL
          as="a"
          href="https://www.compression.ru/video/codec_comparison/2022/ultrafast_report.html#results"
          target="_blank"
          rel="noreferrer"
        >
          https://www.compression.ru/video/codec_comparison/2022/ultrafast_report.html#results
        </BodyTextL>
      </BodyTextL>
    </Av1MSUContainer>
  );
};

export default Av1MSU;

const Av1MSUContainer = styled.div`
  & .img-wrapper {
    position: relative;
    width: 100%;
    padding-top: 65.25%;
  }
  .link-wrapper,
  .link-wrapper a {
    color: ${GRAY50} !important;
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
  }
  .link-wrapper a {
    text-decoration: underline;
  }
`;
